import FieldPhoneNumber from 'shared/Forms/Fields/PhoneNumber/FieldPhoneNumber';
import InputGroupPhone from 'shared/Forms/Inputs/PhoneNumber/InputGroupPhone';
import InputPhoneNumber from 'shared/Forms/Inputs/PhoneNumber/InputPhoneNumber';
import React from 'react';

export default class FieldGroupPhone extends React.Component {
	render() {
		return (
			<FieldPhoneNumber
				className={this.props.className}
				disabled={this.props.disabled}
				inputClass={this.props.inputClass}
				labelClass={this.props.labelClass}
				name={this.props.name}
				required={this.props.required}
				type="group"
			/>
		);
	}
}

FieldGroupPhone.defaultProps = {
	autocomplete: InputPhoneNumber.defaultProps.autocomplete,
	className: InputPhoneNumber.defaultProps.className,
	disabled: InputPhoneNumber.defaultProps.disabled,
	inputClass: InputPhoneNumber.defaultProps.className,
	labelClass: FieldPhoneNumber.defaultProps.labelClass,
	name: InputGroupPhone.defaultProps.name,
	required: InputPhoneNumber.defaultProps.required,
};
